import React, { useCallback } from "react";
import { Button, Form, Input, Layout, Popover } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useDashboardGroupsContext } from "@data-root/react";

const { Content } = Layout;

export const AddGroupButton = () => {
  const { createGroup } = useDashboardGroupsContext();

  const onFinish = useCallback(
    ({ groupId, groupName }: { groupId: string; groupName: string }) => {
      createGroup({ id: groupId, name: groupName, params: {} });
    },
    [createGroup]
  );

  return (
    <Popover
      trigger="click"
      content={
        <Layout>
          <Content>
            <Form layout="vertical" name="New Group" onFinish={onFinish}>
              <Form.Item label="Group ID" name="groupId" required>
                <Input placeholder="ID" />
              </Form.Item>

              <Form.Item label="Group name" name="groupName" required>
                <Input placeholder="Name" />
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  icon={<PlusOutlined />}
                >
                  Add
                </Button>
              </Form.Item>
            </Form>
          </Content>
        </Layout>
      }
    >
      <Button
        style={{ color: "black" }}
        size="small"
        type="link"
        icon={<PlusOutlined />}
      >
        New Group
      </Button>
    </Popover>
  );
};
